var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    autoHide: false,
    trigger: 'hover click focus',
    content: _vm.message,
    placement: _vm.placement,
    delay: {
      show: _vm.showDelay,
      hide: _vm.hideDelay
    },
    classes: _vm.classes
  }),expression:"{\n    autoHide: false,\n    trigger: 'hover click focus',\n    content: message,\n    placement: placement,\n    delay: {\n      show: showDelay,\n      hide: hideDelay\n    },\n    classes\n  }"}],staticClass:"tooltip-component-container"},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }